import {
  Button,
  Container,
  Stack,
} from "react-bootstrap";
import Typography from "@mui/material/Typography";

import NewPaginationControl from "../../components/controls_comp/control-Pagination";
import { useRef, useState } from "react";
import {
  SituacaoPedido,
  SituacaoAnaliseTecnica,
  isBloqueadoTecnico,
  getStyleStatusPedido,
  getStyleBackgroundTicketPedido
} from "../../consts/situacao_pedido";

import {
  faSort,
  faSortAsc,
  faSortDesc,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import T from "../../common/traducao";
import { Box, Button as MuiButton, Grid, IconButton } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";

const PedidosListCards = (
    { 
        constantes, 
        orderField,
        ordertype,
        onPageSelect,
        pedidos,
        pages,
        records,
        onGetStyle,
        onOrderChange,
        setIndexImprimir,
        setModalImprimir,
        buttons,
        onExpanded,
        activeExpand,
        semcontainer,
        msgAviso,
        noselect,
        onItemSelected,
        onRowClick,
        btntype
    }
) => {

    const [indexActive, setIndexActive] = useState();
    const currentsortname = useRef(orderField?.current);
    const currentsorttype = useRef(ordertype?.current);
    const [indexOrder, setIndexOrder] = useState();

    const columns = [
        {
            field: "Id",
            headerName: constantes.Numero,
            width: 90,
            key: true,
        },
        {
            field: "DataCadastro",
            headerName: constantes.DataCadastro,
            width: 90,
            type: "date",
            format: "dd/MM/yyyyy",
        },
        {
            field: "Situacao",
            headerName: constantes.Situacao,
            width: 150,
            type: "custom",
            onGetCustom: (item) => {
                const style = onGetStyle(item);
                return <Button style={style}>{item}</Button>;
            },
        },
        {
            field: "SituacaoComercial",
            headerName: `${constantes.Situacao} ${constantes.Comercial}`,
            width: 150,
            type: "custom",
            onGetCustom: (item) => {
                const style = onGetStyle(item);
                return <Button style={style}>{item}</Button>;
            },
        },
        {
            field: "SituacaoFinanceira",
            headerName: `${constantes.Situacao} ${constantes.Financeiro}`,
            width: 150,
            type: "custom",
            onGetCustom: (item) => {
                const style = onGetStyle(item);
                return <Button style={style}>{item}</Button>;
            },
        },
        {
            field: "SituacaoAnaliseTecnica",
            headerName: `${constantes.Situacao} Análise Técnica`,
            width: 150,
            type: "custom",
            onGetCustom: (item) => {
                const statusName = (item === SituacaoAnaliseTecnica.PENDENTE || item === SituacaoAnaliseTecnica.BLOQUEADA) ? SituacaoPedido.BLOQUEADO_TECNICO : (item || "");
                const style = onGetStyle(statusName);
                const displayText = (statusName === SituacaoPedido.BLOQUEADO_TECNICO) ? (constantes.BloqueadoTec || "Bloqueado Tec.") : statusName;
                return <Button style={style}>{displayText}</Button>;
            },
        },
        {
            field: "DataPrevisaoFaturamento",
            headerName: constantes.DataPrevisaoFaturamento,
            width: 90,
            type: "date",
            format: "dd/MM/yyyyy",
        },
        {
            field: "DataFaturamento",
            headerName: constantes.DataFaturamento,
            width: 90,
            type: "date",
            format: "dd/MM/yyyyy",
        },      
        {
            field: "DataPrevisaoEntrega",
            headerName: constantes.DataPrevisaoEntrega,
            width: 90,
            type: "date",
            format: "dd/MM/yyyyy",
        },  
        {
            field: "ClienteId",
            headerName: `${constantes.Codigo} ${constantes.Cliente}`,
            width: 150,
        },
        {
            field: "ClienteNome",
            headerName: constantes.Cliente,
            width: 150,
        },
        {
            field: "ValorPedido",
            headerName: constantes.TotalPedido,
            width: 150,
            digits: 2,
        },
    ];

    function GetSortType() {
        switch (currentsorttype.current) {
            case "asc":
                return "desc";
            case "desc":
                return "asc";
            default:
                return "asc";
        }
    }

    const GetHeader = (args) => {
        const { item, index } = args;

        const icon =
            currentsorttype.current === "sort"
                ? faSort
                : currentsorttype.current === "asc"
                    ? faSortAsc
                    : faSortDesc;

        const retorno = (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    maxWidth: "500px",
                    overflowX: "auto",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#dddddd",
                        width: "112px",
                        borderRadius: 10,
                        padding: "0.5rem 0.6rem",
                        gap: 1,
                        "@media (max-width: 850px)": {
                            width: "100px"
                        }
                    }}
                    onClick={() => {
                        setIndexOrder(index);
                    }}
                >
                    <Typography
                        sx={{
                            width: "100%",
                            fontSize: "0.875rem",
                            textAlign: "center",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            "@media (max-width: 850px)": {
                                fontSize: "0.75rem",
                            }
                        }}
                    >
                        {item.headerName}
                    </Typography>

                    {indexOrder === index && (
                        <Button
                            style={{
                                background: "transparent",
                                border: "none",
                                padding: 0,
                            }}
                            onClick={(e) => {
                                const sorttype = GetSortType();
                                onOrderChange && onOrderChange(item.field, sorttype);
                                currentsortname.current = item.field;
                                currentsorttype.current = sorttype;
                            }}
                        >
                            <FontAwesomeIcon
                                icon={currentsortname.current === item.field ? icon : faSort}
                                size={1}
                                color="#515151"
                            ></FontAwesomeIcon>
                        </Button>
                    )}
                </Box>
            </Box>
        );

        return onOrderChange ? retorno : item.headerName;
    };

function Headers() {
        return (
            <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                sx={{ width: "100%" }}
                gap={1}
            >
                <Grid
                    item
                    xs={12}
                    display={"flex"}
                    alignItems={"center"}
                    gap={1}
                    sx={{ width: "100%", flexWrap: { xs: "wrap", md: "nowrap" } }}
                >
                    <Typography
                        color={"#666363"}
                        sx={{
                            flexShrink: 0,
                            fontSize: "1rem",
                            "@media (max-width: 550px)": {
                                fontSize: "0.875rem",
                            },
                        }}
                    >
                        {constantes.Ordenarpor}:
                    </Typography>

                    <Box
                        display={"flex"}
                        alignItems={"center"}
                        gap={1}
                        sx={{
                            overflowX: "auto",
                            width: "100%",
                            maxWidth: { xs: "100%", md: "auto" },
                            flexWrap: "nowrap",
                            "&::-webkit-scrollbar": {
                                height: "6px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#ccc",
                                borderRadius: "3px",
                            },
                        }}
                    >
                        {pedidos &&
                            pedidos.length > 0 &&
                            columns &&
                            columns.map((item, index) => {
                                return (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            margin: "0",
                                            justifyContent: "center",
                                            flexShrink: 0,
                                        }}
                                    >
                                        <Box display={"flex"} key={index} p={0}>
                                            <GetHeader item={item} index={index} />
                                        </Box>
                                    </Box>
                                );
                            })}
                    </Box>
                </Grid>
            </Grid>
        );
    }

    function ButtonBodyTable(args) {
        const { itemdata, indexlinha } = args;

        let retorno = null;

        if (btntype && btntype === "dropdown") {
            retorno = buttons?.length > 0 && (
                <Box onClick={(e) => e.stopPropagation()} sx={{ width: "100%" }}>
                    {buttons.map((btn, index) => {
                        const isVisible = btn.isVisible ? btn.isVisible(itemdata) : true;
                        if (!isVisible) return null;
                        return (
                            <Box key={index} sx={{ width: { xs: "100%", sm: "auto" } }}>
                                <MuiButton
                                    variant="outlined"
                                    startIcon={<PrintIcon />}
                                    onClick={() => btn.onClick(indexlinha)}
                                    sx={{
                                        fontSize: "0.875rem",
                                        padding: "8px 16px",
                                        borderColor: "#bdbdbd",
                                        color: "#555",
                                        textTransform: "none",
                                        borderRadius: "8px",
                                        minHeight: "44px",
                                        width: { xs: "100%", sm: "auto" },
                                    }}
                                >
                                    {btn.text}
                                </MuiButton>
                            </Box>
                        );
                    })}
                </Box>
            );
        } else {
            let retorno_botoes =
                buttons &&
                buttons.map((btn, index) => {
                    const isVisible = btn.isVisible ? btn.isVisible(itemdata) : true;
                    const btncalc = btn.getBtn ? (
                        btn.getBtn(itemdata, indexlinha)
                    ) : (
                        <Button
                            key={index}
                            variant={btn.variant}
                            onClick={btn.onClick}
                            value={indexlinha}
                        >
                            {btn.text}
                        </Button>
                    );
                    const _retorno = isVisible ? (
                        <>
                            {isVisible && " "}
                            {isVisible && btncalc}
                        </>
                    ) : null;
                    if (_retorno) {
                        if (!retorno) {
                            retorno = [];
                        }
                        retorno = retorno.concat(_retorno);
                    }
                    return _retorno;
                });
        }

        return retorno ? (
            <Stack direction="horizontal" gap={1} style={{ width: "100%" }}>
                {retorno}
            </Stack>
        ) : null;
    }

    const formatarData = (data) => {
        if (!data) return "";
        const dataFormatada = new Date(data).toLocaleDateString("pt-BR", { timeZone: "UTC" });
        return dataFormatada;
    };

    const formatarValor = (valor) => {
        if (valor === null || valor === undefined) return "R$ 0,00";
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
    };

    const BodyCardsPedidos = () => {
        return (
            pedidos?.length > 0 ?
                pedidos?.map((item, index) => {
                    const dataCadastro = formatarData(item.DataCadastro);
                    const dataPrevisaoFaturamento = formatarData(item.DataPrevisaoFaturamento);
                    const dataFaturamento = formatarData(item.DataFaturamento);
                    const dataPrevisaoEntrega = formatarData(item.DataPrevisaoEntrega);

                    const effectiveStatus = isBloqueadoTecnico(item) ? SituacaoPedido.BLOQUEADO_TECNICO : item.Situacao;
                    const ticketStyle = getStyleBackgroundTicketPedido(item) ?? {};

                    return (
                        <Box
                            display={"flex"}
                            sx={{
                                flexDirection: { xs: "column", sm: "row" },
                                margin: "10px 0",
                                border: "1px solid #e0e0e0",
                                borderRadius: "4px",
                                overflow: "visible",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                                color: "black",
                                fontFamily: "'Roboto', sans-serif",
                                "@media (min-width: 1050px)": {
                                    maxHeight: "215px",
                                    overflow: "hidden",
                                },
                            }}
                        >
                            {/* Seção superior — mobile only: fundo colorido com situação, número, cliente e CPF */}
                            <Box
                                sx={{
                                    display: { xs: "flex", sm: "none" },
                                    flexDirection: "column",
                                    gap: 0.01,
                                    background: ticketStyle.background ?? "#dddddd",
                                    color: "black",
                                    padding: "10px 12px",
                                    borderRadius: "4px 4px 0 0",
                                }}
                            >
                                <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold" }}>{item.Situacao}</Typography>
                                <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold" }}>
                                    {constantes.Numero}: {item.Id}
                                </Typography>
                                <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold", wordBreak: "break-word" }}>
                                    {item.ClienteNome}
                                </Typography>
                            </Box>

                            {/* Barra de cor — desktop only */}
                            <Box sx={{ ...getStyleStatusPedido(effectiveStatus), display: { xs: "none", sm: "block" } }} />

                            {/* Ticket lateral — desktop only */}
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                                justifyContent="center"
                                alignItems="flex-start"
                                gap={{ sm: 1, md: 0.5 }}
                                sx={{
                                    ...getStyleBackgroundTicketPedido(item),
                                    display: { xs: "none", sm: "flex" },
                                    color: "black",
                                    "@media (min-width: 1050px)": {
                                        width: "120px",
                                        minWidth: "120px",
                                        padding: "6px 8px",
                                        gap: "2px",
                                        "& .MuiTypography-root": {
                                            fontSize: "0.65rem",
                                        },
                                    },
                                }}
                            >
                                <Typography sx={{ fontSize: "0.75rem" }}>{item.Situacao}</Typography>

                                <Box display={"flex"} flexDirection={"column"} width={"100%"}>
                                    <Typography sx={{ fontSize: "0.75rem" }}>{constantes.Pedido}</Typography>
                                    <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold" }}>{item.Id}</Typography>
                                </Box>

                                <Box display={"flex"} flexDirection={"column"} width={"100%"}>
                                    <Typography sx={{ fontSize: "0.75rem" }}>{constantes.DataCadastro}</Typography>
                                    <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold" }}>{dataCadastro}</Typography>
                                </Box>

                                {item.SituacaoComercial && (
                                    <Box display={"flex"} flexDirection={"column"} width={"100%"}>
                                        <Typography sx={{ fontSize: "0.75rem" }}>
                                            {constantes.Situacao} {constantes.Comercial}
                                        </Typography>
                                        <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold", wordBreak: "break-word" }}>
                                            {item.SituacaoComercial}
                                        </Typography>
                                    </Box>
                                )}

                                {item.SituacaoFinanceira && (
                                    <Box display={"flex"} flexDirection={"column"} width={"100%"}>
                                        <Typography sx={{ fontSize: "0.75rem" }}>
                                            {constantes.Situacao} {constantes.Financeiro}
                                        </Typography>
                                        <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold", wordBreak: "break-word" }}>
                                            {item.SituacaoFinanceira}
                                        </Typography>
                                    </Box>
                                )}

                                {item.SituacaoAnaliseTecnica && (
                                    <Box display={"flex"} flexDirection={"column"} width={"100%"}>
                                        <Typography sx={{ fontSize: "0.75rem" }}>
                                            {constantes.Situacao} Análise Técnica
                                        </Typography>
                                        <Typography sx={{ fontSize: "0.875rem", fontWeight: "bold", wordBreak: "break-word" }}>
                                            {item.SituacaoAnaliseTecnica || "N/R"}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>

                            {/* Divisor: horizontal no mobile, vertical no desktop */}
                            <Box sx={{
                                alignSelf: "stretch",
                                borderLeft: { xs: "none", sm: "1px solid #e0e0e0" },
                                borderTop: { xs: "1px solid #e0e0e0", sm: "none" },
                            }} />

                            {/* Conteúdo principal + botão */}
                            <Box
                                display={"flex"}
                                sx={{
                                    flex: 1,
                                    minWidth: 0,
                                    padding: { xs: "8px", sm: "10px 8px" },
                                    alignItems: "flex-start",
                                    flexDirection: { xs: "column", sm: "row" },
                                    "@media (min-width: 1050px)": {
                                        padding: "4px 8px",
                                    },
                                }}
                            >
                                <Grid container sx={{ flex: 1, minWidth: 0 }}>

                                    {/* Coluna 1 — Cliente: desktop only (no mobile fica na seção superior) */}
                                    <Grid
                                        item
                                        xs={12}
                                        md={4}
                                        gap={1}
                                        sx={{
                                            minWidth: 0,
                                            flexDirection: "column",
                                            display: { xs: "none", sm: "flex" },
                                            "@media (min-width: 1050px)": { gap: "2px" },
                                        }}
                                    >
                                        <Typography sx={{ width: "100%", wordBreak: "break-word", fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                                            <strong style={{ color: "#606060" }}>{constantes.Cliente}</strong>
                                            : {item.ClienteId} | {item.ClienteNome}
                                        </Typography>

                                        {item.CpfCnpjCliente && (
                                            <Typography sx={{ width: "100%", wordBreak: "break-word", fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                                                <strong style={{ color: "#606060" }}>{constantes.CpfCnpj}</strong>
                                                : {item.CpfCnpjCliente}
                                            </Typography>
                                        )}

                                        <Typography sx={{ width: "100%", wordBreak: "break-word", fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                                            <strong style={{ color: "#606060" }}>{constantes.ApelidoFantasia}</strong>
                                            : {item.ApelidoFantasiaCliente}
                                        </Typography>
                                    </Grid>

                                    {/* DataCadastro — mobile only (no desktop fica no ticket) */}
                                    <Grid
                                        item
                                        xs={12}
                                        gap={0.5}
                                        sx={{ minWidth: 0, flexDirection: "column", display: { xs: "flex", sm: "none" } }}
                                    >
                                        <Typography sx={{ width: "100%", wordBreak: "break-word", fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                                            <strong style={{ color: "#606060" }}>{constantes.DataCadastro}</strong>
                                            : {dataCadastro}
                                        </Typography>
                                    </Grid>

                                    {/* Coluna 2 — Datas */}
                                    <Grid
                                        item
                                        display={"flex"}
                                        flexDirection={"column"}
                                        xs={12}
                                        md={4}
                                        gap={{ xs: 0.5, sm: 1 }}
                                        sx={{ minWidth: 0 }}
                                    >
                                        {dataPrevisaoFaturamento && (
                                            <Typography sx={{ width: "100%", wordBreak: "break-word", fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                                                <strong style={{ color: "#606060" }}>{constantes.DataPrevisaoFaturamento}</strong>
                                                : {dataPrevisaoFaturamento}
                                            </Typography>
                                        )}

                                        {dataFaturamento && (
                                            <Typography sx={{ width: "100%", wordBreak: "break-word", fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                                                <strong style={{ color: "#606060" }}>{constantes.DataFaturamento}</strong>
                                                : {dataFaturamento}
                                            </Typography>
                                        )}

                                        {dataPrevisaoEntrega && (
                                            <Typography sx={{ width: "100%", wordBreak: "break-word", fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                                                <strong style={{ color: "#606060" }}>{constantes.DataPrevisaoEntrega}</strong>
                                                : {dataPrevisaoEntrega}
                                            </Typography>
                                        )}

                                        {/* Situações — mobile only (no desktop ficam no ticket) */}
                                        {item.SituacaoComercial && (
                                            <Typography sx={{ width: "100%", wordBreak: "break-word", fontSize: { xs: "0.875rem", sm: "1rem" }, display: { xs: "block", sm: "none" } }}>
                                                <strong style={{ color: "#606060" }}>{constantes.Situacao} {constantes.Comercial}</strong>
                                                : {item.SituacaoComercial}
                                            </Typography>
                                        )}
                                        {item.SituacaoFinanceira && (
                                            <Typography sx={{ width: "100%", wordBreak: "break-word", fontSize: { xs: "0.875rem", sm: "1rem" }, display: { xs: "block", sm: "none" } }}>
                                                <strong style={{ color: "#606060" }}>{constantes.Situacao} {constantes.Financeiro}</strong>
                                                : {item.SituacaoFinanceira}
                                            </Typography>
                                        )}
                                        {item.SituacaoAnaliseTecnica && (
                                            <Typography sx={{ width: "100%", wordBreak: "break-word", fontSize: { xs: "0.875rem", sm: "1rem" }, display: { xs: "block", sm: "none" } }}>
                                                <strong style={{ color: "#606060" }}>{constantes.Situacao} Análise Técnica</strong>
                                                : {item.SituacaoAnaliseTecnica}
                                            </Typography>
                                        )}
                                    </Grid>

                                    {/* Coluna 3 — Valores */}
                                    <Grid
                                        item
                                        display={"flex"}
                                        flexDirection={"column"}
                                        xs={12}
                                        md={4}
                                        gap={{ xs: 0.5, sm: 1 }}
                                        sx={{ minWidth: 0 }}
                                    >
                                        {item.ValorPedido !== undefined && (
                                            <Typography sx={{ width: "100%", wordBreak: "break-word", fontWeight: "bold", color: "#2e7d32", fontSize: "0.875rem" }}>
                                                <strong style={{ color: "#606060" }}>{constantes.TotalPedido}</strong>
                                                : {formatarValor(item.ValorPedido)}
                                            </Typography>
                                        )}

                                        {item.ValorProdutos !== undefined && (
                                            <Typography sx={{ width: "100%", wordBreak: "break-word", fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                                                <strong style={{ color: "#606060" }}>{constantes.TotalProdutos}</strong>
                                                : {formatarValor(item.ValorProdutos)}
                                            </Typography>
                                        )}

                                        {item.ValorFrete !== undefined && (
                                            <Typography sx={{ width: "100%", wordBreak: "break-word", fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                                                <strong style={{ color: "#606060" }}>{constantes.TotalFrete}</strong>
                                                : {formatarValor(item.ValorFrete)}
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>

                                {/* Botão: abaixo dos dados no mobile, à direita no desktop */}
                                <Box sx={{
                                    flexShrink: 0,
                                    alignSelf: { xs: "stretch", sm: "flex-start" },
                                    paddingTop: { xs: "8px", sm: "2px" },
                                    width: { xs: "100%", sm: "auto" },
                                }}>
                                    <ButtonBodyTable itemdata={item} indexlinha={index} />
                                </Box>
                            </Box>
                        </Box>
                    );
                }) : (
                    <Box sx={{ display: "flex", width: "100%", height: "100%", justifyContent: "center", alignItems: "center", margin: "10rem 0" }}>
                        <Typography sx={{
                            fontSize: { xs: "0.875rem", sm: "1rem" },
                            color: "#919191",
                            fontWeight: "bold",
                            textAlign: "center",
                        }}>{constantes.MsgFiltroNaoEncontradoOrcamentos || "Nenhum registro encontrado"}</Typography>
                    </Box>
                )
        );
    };

    function Children() {
        return (
            <div>
                <h4>{constantes.PedidoVendas || "Pedidos de Venda"}</h4>
                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                    <Headers />
                </Box>
                <BodyCardsPedidos />
                {pedidos?.length !== 0 && (
                    <NewPaginationControl
                        pages={pages}
                        records={records}
                        onPageSelect={(number) => {
                            onPageSelect && onPageSelect(number);
                        }}
                    />
                )}
            </div>
        );
    }

    return semcontainer ? Children() : <Container>{Children()}</Container>;
};

export default PedidosListCards;
